<template>
    <v-form class="customer-customer-msp" ref="customerMspForm" v-on:submit.prevent :value="valid" @input="setValid">
        <v-layout wrap justify-space-between mb-2>
            <v-flex md6 pr-2>
                <v-text-field label="GP-Nummer" disabled :value="gpNumber"></v-text-field>
                <v-select label="Anrede" :items="anreden" :value="anrede" :rules="rules.anrede" :disabled="inAction" @input="setAnrede" />
                <v-text-field label="Titel" :value="titel" :rules="rules.titel" :disabled="inAction" @input="setTitel"></v-text-field>
            </v-flex>
            <v-flex md6 pl-2>
                <v-radio-group
                    column
                    @change="setPortal"
                    label="Portal"
                    :rules="rules.portal"
                    :value="portal"
                    :disabled="inAction">
                    <v-radio
                        v-for="p in portals"
                        :key="p.value"
                        :color="p.color"
                        :value="p.value"
                        :label="p.label"></v-radio>
                </v-radio-group>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between mb-2>
            <v-flex md6 pr-2>
                <v-text-field label="Vorname" :value="vorname" :rules="rules.vorname" disabled @input="setVorname"></v-text-field>
            </v-flex>
            <v-flex md6 pl-2>
                <v-text-field label="Nachname" :value="nachname" :rules="rules.nachname" disabled @input="setNachname"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between mb-2>
            <v-flex md6 pr-2>
                <v-text-field label="Strasse" :value="strasse" :rules="rules.strasse" disabled @input="setStrasse"></v-text-field>
            </v-flex>
            <v-flex md6 pl-2>
                <v-text-field label="Hausnummer" :value="hausnummer" :rules="rules.hausnummer" disabled @input="setHausnummer"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between mb-2>
            <v-flex md6 pr-2>
                <v-text-field label="Postleitzahl" :value="plz" :rules="rules.plz" disabled @input="setPlz"></v-text-field>
            </v-flex>
            <v-flex md6 pl-2>
                <v-text-field label="Ort" :value="ort" :rules="rules.ort" disabled @input="setOrt"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between mb-2>
            <v-flex md6 pr-2>
                <v-text-field label="Land" :value="land" :rules="rules.land" disabled @input="setLand"></v-text-field>
            </v-flex>
            <v-flex md6 pl-2>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between mb-2>
            <v-flex md6 pr-2>
                <v-text-field
                    label="E-Mail"
                    :value="email"
                    :rules="rules.email" @input="setEmail"
                    :disabled="inAction"
                    v-on:keyup="hideEmailAlert"
                ></v-text-field>
                <v-alert class="mt-1" :type="emailAlert.type" v-model="emailAlert.show">
                    {{ emailAlert.message }}
                </v-alert>
            </v-flex>
            <v-flex md6 pl-2>
                <v-text-field label="Geburtsdatum" :value="gebdat" :rules="rules.gebdat" :disabled="inAction" @input="setGebdat"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between mb-2>
            <v-flex md6 pr-2>
                <v-text-field label="Telefon" :value="telnr" :rules="rules.telnr" :disabled="inAction" @input="setTelnr"></v-text-field>
            </v-flex>
            <v-flex md6 pl-2>
            </v-flex>
        </v-layout>
    </v-form>
</template>
<script>
import {
    mapActions,
    mapGetters,
    mapMutations,
    mapState,
} from 'vuex';
import Util from '@/util';

export default {
    name: 'CustomerMsp',
    /*
        gpnr        integer 10
        anrede      string  10
        email       string  240
        gebdat      string  10 yyyy-mm-dd
        telnr       string  20
        titel       string  15
        nachname    string  35
        vorname     string  35
        ort         string  35
        plz         string  5
        hausnummer  string  10
        strasse     string  35
    */
    computed: {
        ...mapState('customerMsp', [
            'gpNumber',
            'valid',
            'emailAlert',
            'inAction',
            'loading',
            'anrede',
            'titel',
            'vorname',
            'nachname',
            'strasse',
            'hausnummer',
            'plz',
            'ort',
            'land',
            'email',
            'gebdat',
            'telnr',
            'portal',
            'scope',
        ]),
        ...mapGetters('customerMsp', ['portals']),
    },
    methods: {
        ...mapActions('customerMsp', []),
        ...mapMutations('customerMsp', [
            'hideEmailAlert',
            'setValid',
            'setAnrede',
            'setTitel',
            'setVorname',
            'setNachname',
            'setStrasse',
            'setHausnummer',
            'setPlz',
            'setOrt',
            'setLand',
            'setEmail',
            'setGebdat',
            'setTelnr',
            'setPortal',
        ]),
    },
    data() {
        return {
            anreden: ['Herr', 'Frau', 'Firma'],
            rules: {
                anrede: [
                    v => this.anreden.indexOf(v) > -1 || 'Ungültige Anrede',
                ],
                titel: [
                    v => v.length <= 10 || 'Titel darf maximal 10 Zeichen lang sein.',
                ],
                portal: [
                    v => !!v || 'Es muss ein Portal ausgewählt werden',
                ],
                vorname: [
                    v => v.length <= 35 || 'Vorname darf maximal 35 Zeichen lang sein.',
                ],
                nachname: [
                    v => !!v || 'Nachname muss gesetzt sein.',
                    v => v.length <= 35 || 'Nachname darf maximal 35 Zeichen lang sein.',
                ],
                strasse: [
                    v => !!v || 'Straße muss gesetzt sein.',
                    v => v.length <= 35 || 'Straße darf maximal 35 Zeichen lang sein.',
                ],
                hausnummer: [
                    v => !!v || 'Hausnummer muss gesetzt sein.',
                    v => v.length <= 10 || 'Hausnummer darf maximal 10 Zeichen lang sein.',
                ],
                plz: [
                    v => !!v || 'Postleitzahl muss gesetzt sein.',
                    v => v.length <= 5 || 'Postleitzahl darf maximal 5 Zeichen lang sein.',
                ],
                ort: [
                    v => !!v || 'Ort muss gesetzt sein.',
                    v => v.length <= 35 || 'Ort darf maximal 35 Zeichen lang sein.',
                ],
                land: [
                    v => !!v || 'Land muss gesetzt sein.',
                    v => v.length <= 35 || 'Land darf maximal 35 Zeichen lang sein.',
                ],
                email: [
                    v => !!v || 'Email muss gesetzt sein.',
                    v => /.+@.+/.test(v) || 'Email muss gültig sein.',
                    v => v.length <= 240 || 'Email darf maximal 240 Zeichen lang sein.',
                ],
                gebdat: [
                    v => (Util.isValidGermanDate(v) || !v.trim().length) || 'Geburtsdatum entspircht nicht dem Format TT.MM.JJJJ',
                ],
                telnr: [
                    v => v.length <= 20 || 'Telefonnummer darf maximal 20 Zeichen lang sein.',
                ],
            },
        };
    },
};

</script>
<style scoped lang="scss"></style>
